'use strict';

var App = require('app');
var Decorator = require('utils/decoration');
var i18n = require('utils/i18n');
var Notification = require('utils/notification');

var OnsiteAccessWizardView = Marionette.LayoutView.extend({
    template: require('components/devices/templates/gateway/onsite_access_wizard'),

    ui: {
        note: '#js-note-input',
    },

    events: {
        'click #js-next': 'grantAccess',
    },

    initialize: function (options) {
        this.deviceID = options.deviceID;
        this.activeTab = 1;
    },

    serializeData: function () {
        return {
            activeTab: this.activeTab,
            expirationDate: this.expirationDate,

            num1: this.num1,
            num2: this.num2,
        };
    },

    onsiteAccessRequest: function () {
        var defer = $.Deferred();
        App.ajax({
            method: 'POST',
            url: '/api/v1/devices/' + this.deviceID + '/onsite-access',
            data: JSON.stringify({ note: this.ui.note.val() }),
            success: function (data) {
                defer.resolve(data);
            },
            error: function () {
                defer.reject();
            },
        });
        return defer.promise();
    },

    grantAccess: function () {
        var self = this;
        var req = this.onsiteAccessRequest();
        Decorator.disableElement('.modal-dialog');

        $.when(req)
            .then(function (data) {
                var zeroPad = function (num, digits) {
                    return '0'.repeat(digits - Math.log10(num + 1)) + (num || '');
                };

                self.activeTab = 2;

                self.num1 = zeroPad(parseInt(data.pin / 1000), 3);
                self.num2 = zeroPad(parseInt(data.pin % 1000), 3);

                var date = new Date(data.date);
                self.expirationDate = zeroPad(date.getHours(), 2) + ':' + zeroPad(date.getMinutes(), 2);

                self.render();
                Decorator.enableElement('.modal-dialog');
            })
            .fail(function () {
                Notification.show('error', i18n.TR('Fehler'), i18n.TR('Gerätefreigabe fehlgeschlagen.'));

                self.render();
                Decorator.enableElement('.modal-dialog');
            });
    },
});

module.exports = OnsiteAccessWizardView;
